var _this = this;
import * as tslib_1 from "tslib";
import { PageMap, Topology } from '@wix/wixstores-client-core/dist/es/src/constants';
import { productMapper } from '@wix/wixstores-platform-common/dist/src/products/product.mapper';
import { query as getProductQuery } from '../graphql/getProducts.graphql';
import { query as slugQuery } from '../graphql/getProductsBySlug.graphql';
import { query as getProductWithSeoQuery } from '../graphql/getProductsWithSeo.graphql';
import { query as slugWithSeoQuery } from '../graphql/getProductsBySlugWithSeo.graphql';
import { GRAPHQL_SOURCE } from '../constants';
import { parseUrl } from '@wix/native-components-infra/dist/src/urlUtils';
export function getProductBySlug(siteStore, slug, externalId) {
    var productsQueryVariables = {
        slug: slug,
        externalId: externalId,
    };
    var query;
    if (siteStore.experiments.enabled('specs.stores.RenderPromoteSeoTags')) {
        query = slugWithSeoQuery;
    }
    else {
        query = slugQuery;
    }
    return gqlQuery(siteStore, query, productsQueryVariables, "getProductBySlug" /* GetProductBySlug */);
}
export function getDefaultProduct(siteStore, externalId) {
    var productsQueryVariables = {
        limit: 1,
        sort: { sortField: 'CreationDate', direction: 'Descending' },
        filters: null,
        externalId: externalId,
    };
    var query;
    if (siteStore.experiments.enabled('specs.stores.RenderPromoteSeoTags')) {
        query = getProductWithSeoQuery;
    }
    else {
        query = getProductQuery;
    }
    return gqlQuery(siteStore, query, productsQueryVariables, "getDefaultProduct" /* GetDefaultProduct */);
}
export function gqlQuery(siteStore, query, variables, operationName) {
    return siteStore.httpClient.post(siteStore.resolveAbsoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL), {
        query: query,
        variables: variables,
        source: GRAPHQL_SOURCE,
        operationName: operationName,
    });
}
var fetchProduct = function (siteStore, isDefault) {
    if (isDefault === void 0) { isDefault = false; }
    return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var encodedProductName, productName, query, response, json;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    encodedProductName = siteStore.location.path[siteStore.location.path.length - 1];
                    productName = decodeURIComponent(encodedProductName);
                    query = {
                        method: 'post',
                        headers: { Authorization: siteStore.instance },
                        body: JSON.stringify({
                            query: {
                                filter: JSON.stringify({ slug: productName }),
                            },
                        }),
                    };
                    if (isDefault) {
                        query.body = JSON.stringify({
                            query: {
                                sort: JSON.stringify([{ numericId: 'desc' }]),
                                paging: { limit: 1, offset: 0 },
                            },
                        });
                    }
                    return [4 /*yield*/, fetch(siteStore.resolveAbsoluteUrl("/_api/catalog-server/api/v1/products/query"), query)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    return [2 /*return*/, json.products && json.products[0]];
            }
        });
    });
};
export function WixCodeGetProductBySlag(siteStore) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var product;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchProduct(siteStore)];
                case 1:
                    product = _a.sent();
                    if (product) {
                        return [2 /*return*/, productMapper(product)];
                    }
                    else {
                        throw new Error('product not found');
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function getUrlWithoutParams(url) {
    var parsedUrl = parseUrl(url);
    return parsedUrl.protocol + "://" + parsedUrl.host + parsedUrl.path;
}
export function wixCodeGetProduct(siteStore, reportError) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var currentUrl, sectionUrl, defaultProduct, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, , 8]);
                    if (!siteStore.experiments.enabled('specs.stores.DefaultProductInWixCode')) return [3 /*break*/, 5];
                    currentUrl = getUrlWithoutParams(siteStore.location.url);
                    return [4 /*yield*/, siteStore.getSectionUrl(PageMap.PRODUCT)];
                case 1:
                    sectionUrl = (_a.sent()).url;
                    if (!((siteStore.isPreviewMode() && siteStore.location.path.length > 1) ||
                        (siteStore.isSiteMode() && currentUrl !== sectionUrl))) return [3 /*break*/, 2];
                    return [2 /*return*/, WixCodeGetProductBySlag(siteStore)];
                case 2: return [4 /*yield*/, fetchProduct(siteStore, true)];
                case 3:
                    defaultProduct = _a.sent();
                    if (defaultProduct) {
                        return [2 /*return*/, productMapper(defaultProduct)];
                    }
                    else {
                        throw new Error('product not found');
                    }
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5: return [2 /*return*/, WixCodeGetProductBySlag(siteStore)];
                case 6: return [3 /*break*/, 8];
                case 7:
                    e_1 = _a.sent();
                    reportError(e_1);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=getProduct.js.map